<div class="mainstepcontent row w100">
  <div class="leftside col grow-1 gap-24">
    <div class="col gap-16">
      <div class="col">
        <div class="stepcounter">
          STEP {{ thisStepCount }}/{{ totalStepCount }}
        </div>
        <h1>{{ step.stepTypeName }}</h1>
      </div>
      <div class="instructions align-center row gap-8 pointer">
        <rr-icon name="info"></rr-icon>
        <div class="underline">Instructions</div>
      </div>
    </div>
  </div>
  <div class="rightside col"></div>
</div>
<div class="footer row align-center">
  <div class="leftside row gap-16 align-center">
    <rr-btn type="Primary" [disabled]="nextBtnDisabledStatus">Next Step</rr-btn>
    <rr-btn type="Link" iconStart="arrow-left" size="medium">Back</rr-btn>
  </div>
  <div class="middle row grow-1 align-center justify-center">
    <div class="inner align-center row">
      <div class="stepcounter">
        STEP {{ thisStepCount }}/{{ totalStepCount }}
      </div>
      <rr-progress [progress]="progress"></rr-progress>
    </div>
  </div>
  <div class="rightside row gap-16 align-center">
    <rr-btn type="Secondary" size="Small" iconStart="upload"
      >Upload Knowledge</rr-btn
    >
    <rr-btn type="Secondary" size="Small" iconStart="add">Show Result</rr-btn>
  </div>
</div>
